module.exports = __webpack_public_path__ + "img/wx_system.7ebf78a1.png";